import { Progress } from "@components/progress";
import { StatusTagType } from "@components/StatusTag";
import { X } from "@phosphor-icons/react";
import React from "react";
import { createSearchParams, Link, useLocation } from "react-router-dom";

interface OnboardingHeaderProps {
  title: React.ReactNode;
  progress: number; // 0-100
  estimatedTime?: number; // in minutes
  exitPath?: string;
  status?: StatusTagType;
  hideExitButton?: boolean;
}

export const OnboardingHeader: React.FC<OnboardingHeaderProps> = ({
  title,
  progress,
  estimatedTime,
  exitPath = "/",
  hideExitButton = false,
  status = "in-progress",
}) => {
  const location = useLocation();
  const isReadOnly =
    new URLSearchParams(location.search).get("readOnly") === "true";

  return (
    <>
      <div className="w-full py-4 px-6 flex justify-between items-center">
        <div className="flex flex-col gap-y-2">
          {/* {status && <StatusTag type={status} />} */}
          <h1 className="text-2xl font-semibold leading-9 text-primary leading-trim-both text-edge-cap">
            {title}
          </h1>
        </div>

        <div>
          <div className="flex justify-between items-center gap-4">
            {estimatedTime && (
              <div className="flex items-center flex-col">
                <span className="text-[#8D8D8D] font-instrument text-xs font-semibold leading-8 tracking-[0.44px] uppercase">
                  Estimated Time
                </span>
                <span className="text-primary text-base font-semibold leading-8 leading-trim-both text-edge-cap">
                  ~{estimatedTime}
                </span>
              </div>
            )}
            {/* Exit button */}
            {!hideExitButton && (
              <Link
                to={{
                  pathname: exitPath,
                  search: isReadOnly
                    ? createSearchParams({ readOnly: "true" }).toString()
                    : "",
                }}
                title="Exit"
                className="text-[#B3AF8F]"
              >
                <X
                  size={30}
                  className="hover:bg-gray-100 rounded-sm transition-colors"
                />
              </Link>
            )}
          </div>
        </div>
      </div>
      <Progress value={progress} className="w-full" />
    </>
  );
};
